<template>
  <div class="record-chart">
    <div class="record-table">
      <vxe-grid
        border
        show-overflow
        resizable
        ref="goodsValueTableRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        :edit-disabled="false"
        :edit-config="{ trigger: 'click', mode: 'row' }"
        @edit-actived="editActivedEvent"
        :data="tableData"
        :toolbar="{}"
        :valid-config="{ autoPos: true, message: 'inline' }"
        height="300"
        :footer-method="footerMethod"
        show-footer
      >
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columns"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :edit-render="item.editRender"
        >
          <template v-slot="{ row }">
            <span v-if="item.field == 'goodsType'">{{
              getName('goodsType', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'goodsCategory'">{{
              getName('goodsCategory', row[item.field])
            }}</span>
            <span v-else>{{ row[item.field] }}</span>
          </template>
          <template v-slot:edit="{ row }">
            <el-input-number
              :precision="2"
              :min="null"
              :disabled="isDisabledGoods || isEdit"
              :controls="false"
              v-if="item.editRender.name == 'price'"
              v-model="row[item.field]"
              @input="handleChange(row, 'price')"
            ></el-input-number>
            <el-select
              v-if="item.editRender.name == 'goodsType'"
              filterable
              clearable
              disabled
              v-model="row[item.field]"
              @change="(val) => goodsTypeChange(row, val)"
            >
              <el-option
                v-for="(i, index) in goodsTypeList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'goodsCategory'"
              filterable
              clearable
              disabled
              v-model="row[item.field]"
            >
              <el-option
                v-for="(i, index) in goodsCategoryList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-input
              v-else-if="item.editRender.name == 'input'"
              disabled
              v-model="row[item.field]"
            ></el-input>
            <el-input-number
              :precision="2"
              :min="0"
              :controls="false"
              :disabled="isDisabledGoods || isEdit"
              v-if="item.editRender.name == 'safeValue'"
              v-model="row[item.field]"
            ></el-input-number>
            <el-input-number
              :precision="2"
              :min="0"
              disabled
              :controls="false"
              v-if="item.editRender.name == 'stockValue'"
              v-model="row[item.field]"
            ></el-input-number>
            <el-input
              v-else-if="item.editRender.name == 'remark'"
              disabled
              v-model="row[item.field]"
            ></el-input>
          </template>
        </vxe-table-column>
      </vxe-grid>
    </div>
  </div>
</template>

<script>
  import { chartColumns } from './index.js';
  import BASE_API from '@/api/dataBase';
  import goodsApi from '@/api/masterData/goods.js';
  export default {
    name: 'pledgeTable',
    props: {
      tableDataList: {
        type: Array,
        default: () => [],
      },
      showTableBtn: {
        type: Boolean,
        default: true,
      },
      isDisabledGoods: {
        type: Boolean,
        default: false,
      },
      billStatus: {
        type: String,
        default: () => '',
      },
    },
    data() {
      return {
        tableTotal: 0,
        isEdit: true,
        selectionList: [],
        tableData: [],
        columns: [],
        goodsTypeList: [],
        status: '',
        isMaintain: true,
        goodsCategoryOptions: [],
        pricingStandardList: [],
        goodsCategoryAll: [],
        pricingUnitList: [],
        goodsValueList: [
          { value: 0, label: '否' },
          { value: 1, label: '是' },
        ],
        groupCategoryUrl: BASE_API.GET_PRODUCT_CAT_TREE,
      };
    },
    mounted() {
      this.status = this.$route.query?.status;
      if (this.status == 'detail' || this.status == 'approval') {
        this.isMaintain = true;
      } else {
        this.isMaintain = false;
      }
      this.columns = chartColumns(this);
      this.getGoodsParentApi(); // 获取商品大类
      this.getGoodsCategoryAll(); //获取全部商品品
    },
    methods: {
      // 得到表格数据
      fullTableData(tableData) {
        this.tableData = tableData;
      },
      // 计算和
      sumNum(list, field) {
        let count = 0;
        list.forEach((item) => {
          count += parseFloat(item[field]);
        });
        return count;
      },
      // 获取全部货物品类
      async getGoodsCategoryAll() {
        const { data } = await this.$axios.post(goodsApi.GOODS_LIST_BY_TYPE, {
          parentProductStatus: 'ZT03',
          selectCompanyCode: this.userInfo.companyCode,
          adminFlag: this.userInfo.adminFlag,
        });
        if (data.code == 0) {
          this.goodsCategoryAll = data.data;
        } else {
          console.error('获取货物品类数据失败');
        }
      },
      // 获取商品大类数据
      async getGoodsParentApi() {
        const { data } = await this.$axios.post(goodsApi.PRODUCT_TYPE, {
          parentProductStatus: 'ZT03',
          selectCompanyCode: this.userInfo.companyCode,
          adminFlag: this.userInfo.adminFlag,
        });
        if (data.code == 0) {
          this.goodsTypeList = data.data?.map((item) => {
            return {
              value: item.parentProductNo,
              label: item.productChName,
            };
          });
        } else {
          console.error('获取商品大类数据失败');
        }
      },
      // 表格行数据激活时事件
      editActivedEvent({ row }) {
        this.updateCategory(row);
      },
      // 根据选择的货物类型更新货物品类下拉
      updateCategory(row) {
        const goodsType = row.goodsType;
        if (goodsType) {
          const productParentCode = this.goodsTypeList
            .filter((item) => goodsType.includes(item.value))
            .map((item) => item.value);
          const item = this.goodsCategoryAll.filter(
            (item) => item.productParentCode == productParentCode
          );
          if (item) {
            this.goodsCategoryList = item.map((item) => {
              return {
                value: item.productDetailCode,
                label: item.productChName,
              };
            });
          }
        }
      },
      // 表尾合计
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['stockValue'].includes(column.property)) {
              const result = this.sumNum(data, column.property);
              if (result) {
                return result;
              }
              return null;
            }
            return null;
          }),
        ];
      },
      // 获取表格数据
      getTableData() {
        const $table = this.$refs.goodsValueTableRef;
        return $table.getTableData().fullData;
      },
      // 单价被修改时事件
      handleChange(row, field) {
        if (field === 'price') {
          row['stockValue'] = (row['price'] * row['quantity']).toFixed(2) || 0;
        }
      },
      // 替换显示表格中value为label
      getName(type, value) {
        if (value == null) {
          return '';
        }
        let item;
        if (type == 'goodsType') {
          if (!this.goodsTypeList.length) {
            return '';
          }
          item = this.goodsTypeList.find((item) => item.value == value);
          return item?.label;
        } else if (type == 'goodsCategory') {
          if (!this.goodsCategoryAll.length || value == '') {
            return '';
          }
          item = this.goodsCategoryAll.find((item) => item.productDetailCode == value);
          return item?.productChName;
        }
      },
    },
    watch: {
      tableDataList: {
        handler(val) {
          if (val && val.length) {
            this.fullTableData(val);
            this.tableData.forEach((item, index) => {
              if (item.price) {
                item.stockValue = item.price * val[index].quantity;
              }
            });
          }
        },
        immediate: true,
      },
      isDisabledGoods: {
        handler(val) {
          this.isDisabledGoods = val;
        },
        immediate: true,
      },
      billStatus: {
        handler(val) {
          if (val == '01' || val == '11') {
            this.isEdit = false;
          }
          console.log('this.isEdit', this.isEdit, this.isDisabledGoods);
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .record-chart {
    background: #fff;

    .record-table {
      box-sizing: border-box;
      padding-top: 0;
    }
    .vxe-table-element {
      margin-top: -50px;
    }
  }
</style>
